// extracted by mini-css-extract-plugin
export default {"file":"FileItem_file__TaqVO","icon":"FileItem_icon__+jV6E","title":"FileItem_title__E5ZDB"};